import Http from 'lib/http';

import { INewsForBanner } from './types';

export const fetchNewsForBanner = (fetcher = Http): Promise<INewsForBanner[]> => {
  return fetcher.get('news_banners');
};
